import { FormValidations} from "features/shared/forms/hooks/useForm";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";

export const distRateCircuitBreakerFormValidations = (): FormValidations => {
  return {
    DESC_TMZMSMLEESMLOUVA: {
      required: true,
      type: "OnlyRequired"
    },
    DESC_TMZMSMLEEDATUMPOZZME: {
      required: true,
      type: "OnlyRequired"
    },
    DESC_TMZMSMLEEJISTIC: {
      required: true,
      type: "Pattern",
      regex: /^(\d+(?:[\.\,]\d{1,2})?)$/,
      message: "invalidTwoDecimalsNumber"
    } as PatternValidatonRule
  };
}